import type {
  HourValues,
  JobValues,
  RecurrenceExceptionValues,
  TaskValues,
} from "../schemas/job";
import type {
  HourInput,
  Job,
  JobInput,
  RecurrenceExceptionInput,
  TaskInput,
} from "../types";

export function toJobInput(values: JobValues): JobInput {
  return {
    lockVersion: values.lockVersion,
    workerId: values.workerId,
    functionId: values.functionId,
    categoryId: values.categoryId,
    holidayActionId: values.holidayActionId,
    billingId: values.billingId,
    refundLunch: values.refundLunch,
    refundRide: values.refundRide,
    inContract: values.inContract,
    startDate: values.startDate,
    stopDate: values.stopDate,
    tasks: values.tasks.map(toTaskInput),
  };
}

function toTaskInput(task: TaskValues): TaskInput {
  return {
    id: task.id,
    serviceGroupId: task.serviceGroupId,
    typeId: task.typeId,
    workCategoryId: task.workCategoryId,
    dayLagId: task.dayLagId,
    timeLagId: task.timeLagId,
    hours: task.hours.map(toHourInput),
    recurrence: {
      rule: task.recurrence.rule,
      exceptions: task.recurrence.exceptions.map(toExceptionInput),
    },
  };
}

function toHourInput(hour: HourValues): HourInput {
  return {
    id: hour.id,
    begin: hour.begin,
    end: hour.end,
    statusId: hour.statusId,
  };
}

function toExceptionInput(
  exception: RecurrenceExceptionValues,
): RecurrenceExceptionInput {
  return {
    id: exception.id,
    type: exception.type,
    start: exception.start,
    stop: exception.stop,
    nbWeeks: exception.nbWeeks,
  };
}

export function toJobValues(job: Job): JobValues {
  return {
    lockVersion: job.lockVersion,
    workerId: job.workerId,
    functionId: job.functionId,
    categoryId: job.categoryId,
    holidayActionId: job.holidayActionId,
    billingId: job.billingId,
    refundLunch: job.refundLunch,
    refundRide: job.refundRide,
    inContract: job.inContract,
    startDate: job.startDate,
    stopDate: job.stopDate,
    tasks: job.tasks.map((task) => ({
      id: task.id,
      serviceGroupId: task.serviceGroupId,
      typeId: task.typeId,
      workCategoryId: task.workCategoryId,
      dayLagId: task.dayLagId,
      timeLagId: task.timeLagId,
      hours: task.hours.map((hour) => ({
        id: hour.id,
        begin: hour.begin,
        end: hour.end,
        statusId: hour.statusId,
      })),
      recurrence: {
        rule: task.recurrence.rule,
        exceptions: task.recurrence.exceptions.map((exception) => ({
          id: exception.id,
          type: exception.type,
          start: exception.start,
          stop: exception.stop,
          nbWeeks: exception.nbWeeks,
        })),
      },
      deletable: task.deletable,
    })),
  };
}
